import styled from 'styled-components';

export const FieldWrapperStyled = styled.div`
  padding-top: 24px;

  ${({ size }) => {
    switch (size) {
      case 'small': {
        return `
          max-width: 120px;
        `;
      }
      case 'medium': {
        return `
          max-width: 240px;
        `;
      }
      case 'large': {
        return `
          max-width: 360px;
        `;
      }
    }
  }}
`;
